/**
 * @flow weak
 */

import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import request from '../../lib/request';
import waitForSession from '../../lib/wait-for-session';
import Config from 'config';
import { getListingId } from './getters.js';
import { SESSION_FETCH_WISHLIST_PENDING } from '../session/actions.js';

export const FETCH_LISTING_PENDING = 'FETCH_LISTING_PENDING';
export const FETCH_LISTING_SUCCESS = 'FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_FAILURE = 'FETCH_LISTING_FAILURE';
export const FLAG_LISTING = 'FLAG_LISTING';
export const FLAG_LISTING_SUCCESS = 'FLAG_LISTING_SUCCESS';
export const FLAG_LISTING_FAILURE = 'FLAG_LISTING_FAILURE';
export const UPDATE_EVENT_PENDING = 'UPDATE_EVENT_PENDING';
export const UPDATE_EVENT_SUCCESS = 'UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'UPDATE_EVENT_FAILURE';
export const WISHLIST_LISTING = 'WISHLIST_LISTING';
export const WISHLIST_LISTING_SUCCESS = 'WISHLIST_LISTING_SUCCESS';
export const WISHLIST_LISTING_FAILURE = 'WISHLIST_LISTING_FAILURE';
export const UNWISHLIST_LISTING = 'UNWISHLIST_LISTING';
export const UNWISHLIST_LISTING_SUCCESS = 'UNWISHLIST_LISTING_SUCCESS';
export const UNWISHLIST_LISTING_FAILURE = 'UNWISHLIST_LISTING_FAILURE';


//-----------------------------------------------------------------------------
// Actions
//-----------------------------------------------------------------------------

export function putListing(id, data) {
  const options = {
    method: 'PUT',
    body: JSON.stringify({ listing: data }),
    credentials: 'include',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };

  return request(`${Config.api.base}/listings/${id}`, options)
  .then((response) =>{
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response.json();
  });
}

export const fetchId = (id) => {
  return {
    type: FETCH_LISTING_PENDING,
    id
  };
};

export const flagEvent = () => {
  return {
    type: FLAG_LISTING
  };
};

export const updateEvent = (id, changes) => {
  return {
    type: UPDATE_EVENT_PENDING,
    id,
    changes
  };
};

export const wishlist = () => {
  return {
    type: WISHLIST_LISTING
  };
};

export const unWishlist = () => {
  return {
    type: UNWISHLIST_LISTING
  };
};

//-----------------------------------------------------------------------------
// rootSagas - watchers
//-----------------------------------------------------------------------------

export function* fetchListingPending() {
  yield takeLatest(FETCH_LISTING_PENDING, fetchListing);
}

export function* flagListingWatcher() {
  yield takeEvery(FLAG_LISTING, flagListing);
}

export function* updateEventWatcher() {
  yield takeLatest(UPDATE_EVENT_PENDING, updateListing);
}

export function* wishlistListingWatcher() {
  yield takeEvery(WISHLIST_LISTING, wishlistListing);
}

export function* unWishlistListingWatcher() {
  yield takeEvery(UNWISHLIST_LISTING, unWishlistListing);
}

//-----------------------------------------------------------------------------
// Sagas
//-----------------------------------------------------------------------------

export function* fetchListing({ id })  {
  function listing(id) {
    const options = {
      credentials: 'include'
    };

    return request(`${Config.api.base}/listings/${id}`, options)
      .then(res => res.json());
  }

  try {
    const data = yield listing(id);

    yield put({ type: FETCH_LISTING_SUCCESS, data });
  }
  catch (e) {
    yield put({ type: FETCH_LISTING_FAILURE, e });
  }
}

export function* flagListing()  {
  function flag(id) {
    const options = {
      method: 'POST'
    };

    return request(`${Config.api.base}/listings/${id}/flag`, options);
  }

  try {
    const listingId = yield select(getListingId);
    const data = yield flag(listingId);
    yield put({ type: FLAG_LISTING_SUCCESS, data });
  }
  catch (e) {
    yield put({ type: FLAG_LISTING_FAILURE, e });
  }
}

export function* wishlistListing()  {
  function wishlist(user) {
    const options = {
      method: 'POST',
      credentials: 'include'
    };

    return request(`${Config.api.base}/listings/${user}/wishlist`, options)
      .then(res => res.json());
  }

  try {
    const listingId = yield select(getListingId);
    const data = yield wishlist(listingId);

    yield put({ type: WISHLIST_LISTING_SUCCESS, data });
    yield put({ type: SESSION_FETCH_WISHLIST_PENDING });
  }
  catch (e) {
    yield put({ type: WISHLIST_LISTING_FAILURE, e });
  }
}

export function* unWishlistListing()  {
  function unWishlist(user) {
    const options = {
      method: 'DELETE',
      credentials: 'include'
    };

    return request(`${Config.api.base}/listings/${user}/wishlist`, options)
      .then(res => res.json());
  }

  try {
    const listingId = yield select(getListingId);
    const data = yield unWishlist(listingId);

    yield put({ type: UNWISHLIST_LISTING_SUCCESS, data });
    yield put({ type: SESSION_FETCH_WISHLIST_PENDING });
  }
  catch (e) {
    yield put({ type: UNWISHLIST_LISTING_FAILURE, e });
  }
}

export function* updateListing({ id, changes }) {
  yield call(waitForSession);
  try {
    const data = yield putListing(id, changes);
    yield put({ type: UPDATE_EVENT_SUCCESS, data });
  }
  catch (e) {
    yield put({ type: UPDATE_EVENT_FAILURE, e });
  }
}



// WEBPACK FOOTER //
// ./src/modules/listing/actions.js